import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import React from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";

export const ModalCancelBulkDebit = ({
  show,
  toggle,
  handleDeleteMandate,
  isDeleting,
  mandate
}) => {
  const navigate = useNavigate();
  return (
    <Modal
      centered
      show={show}
      onHide={toggle}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        {/* <div> */}
        <Modal.Title>Cancel debit</Modal.Title>
        {/* </div> */}
      </Modal.Header>
      <Modal.Body>
        <p>Are you sure you want to cancel this debit slated for <span style={{fontWeight: 600}}> {moment(mandate?.runAt).format('DD MMM, YYYY')} &nbsp; {moment(mandate?.runAt).format('hh:mm A')}</span>?</p>
        <code style={{ color: "red" }}>Note: This cannot be undone</code>
      </Modal.Body>
      <Modal.Footer>
        <Button
          style={{
            backgroundColor: "#007dcc",
            fontSize: "0.8rem",
            fontWeight: 500,
          }}
          onClick={handleDeleteMandate}
          disabled={isDeleting}
        >
          {isDeleting ? "Please wait..." : "Confirm"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
